import React, { useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
    numberFormat,
    getTodayDate,
    getType,
    selectDropdownStyle,
    getBranchId,
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";
import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import { getAllProducts } from './../../../Helpers/apiCalls/Manage/Products';
import { getStoreDiscountReport, getStoreDiscountReportPotato } from './../../../Helpers/apiCalls/Reports/DailyOrdersApi';
import Footer from "../../../Components/Footer/Footer";
import { useEffect } from "react";
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination";

export default function StoreDiscountReport() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();

    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        transaction_type: "store",
        branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
        page: 1
    })
    const [branches, setBranches] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [allData, setAllData] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [totalSales, setTotalSales] = useState(0);
    const [totalDiscount, setTotalDiscount] = useState(0);
    const [selectedRow, setSelectedRow] = useState([]);
    const [items, setItems] = useState([]);
    const today = Moment().format("MM/DD/YYYY");
    const [excelData, setExcelData] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

    
    const xlsxHeaders = [
        "ORDER NO",
        "ORDER DATE",
        "BRANCH",
        "SUBTOTAL",
        "DISCOUNT",
        "DISCOUNT DETAILS",
        "GRAND TOTAL",
        "REMARKS",
    ]

    const excelHeaders = [
        { label: "ORDER NO", key: "order_no" },
        { label: "ORDER DATE", key: "order_date" },
        { label: "BRANCH", key: "branch" },
        { label: "SUBTOTAL", key: "subtotal" },
        { label: "DISCOUNT", key: "discount" },
        { label: "DISCOUNT DETAILS", key: "discount_details" },
        { label: "GRAND TOTAL", key: "grand_total" },
        { label: "REMARKS", key: "remarks" },
    ];

    async function fetchBranches() {
        setBranches([])
        
        const response = await getAllBranches();
        if (response.error) {
        } else {
            var allBranches = response.data.data.data
            .filter((data) => { return (data.is_franchise !== "3" && data.is_franchise !== "1")})
            .map((data) => {
                var branch = data;
                branch.label = data.name
                branch.value = data.id
                return branch;
            });
            if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
                var filteredBranch = allBranches.filter((data) => {
                return data.id === getBranchId()
                })
                setBranches(filteredBranch);
            } else {
                setBranches([{label: "All Branches", value:""}, ...allBranches]);
            }
        }
    }
    
    async function fetchAllProducts() {
        setItems([])
        
        const response = await getAllProducts();

        if (response.data) {
            var data = response.data.data.data.map((item) => {
                var info = item;
                info.label = item.name
                info.value = item.id
                return info;
            });
            setItems([{label: "All Products", value:""}, ...data]);
        }
    }

    async function fetchData() {
        setShowLoader(true);
        setAllData([])
        setExcelData([])
        setTotalQuantity(0);
        setTotalSales(0);
        setTotalDiscount(0);
        setTotalItems(0)

        const response = await getStoreDiscountReport(filterConfig);
        if (response.data) {
            var allBills = response.data.data.discounts_per_order.map((bill) => {
                var items = ""
                var info = bill;
                info.order_date = Moment(bill.order_date).format("MM-DD-YYYY")
                info.subtotal = numberFormat(bill.subtotal)
                info.discount = numberFormat(bill.discount)
                info.grand_total = numberFormat(bill.grand_total)
                return info;
            });
            setAllData(allBills)

            var excel = allBills.map((bill) => {
                var info = {};
                info.order_no = bill.order_no
                info.order_date = bill.order_date
                info.branch = bill.branch
                info.subtotal = bill.subtotal
                info.discount = bill.discount
                info.discount_details = bill.discount_details
                info.grand_total = bill.grand_total
                info.remarks = bill.remarks
                return info;
            });
            setExcelData(excel)

            // var total_qty = response.data.summary? response.data.summary.total_qty : "0";
            var total_sales = response.data.summary? response.data.summary.total_sales : "0";
            var total_discount = response.data.summary? response.data.summary.total_discount : "0";
            // setTotalQuantity(total_qty);
            setTotalSales(total_sales);
            setTotalDiscount(total_discount);
            setTotalItems(response.data.size);
        }
        setShowLoader(false);
    }

    function handleExport() {
        const rows = excelData
        
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
        XLSX.writeFile(workbook, "StoreDiscountReport.xlsx", { compression: true });
    }

    useEffect(() => {
        fetchBranches();
    }, [filterConfig]);

    useEffect(() => {
        fetchData();
    }, [filterConfig, currentPage]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"STORE REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}

                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> STORE DISCOUNT REPORT </h1>
                    </Col>
                </Row>

                <div className="tab-content">
                    {/* filters */}
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            styles={selectDropdownStyle}
                            options={branches}
                            onChange={(e) => { setFilterConfig((prev) => {
                                    return { ...prev, "branch_id": e.value };
                                });}}
                        />
                        </Col>
                        <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                        <Form.Select
                            name="transaction_type"
                            className="date-filter force-width w-full"
                            value={filterConfig.transaction_type}
                            onChange={(e) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, transaction_type: e.target.value };
                                });
                            }}
                        >
                            <option value="" selected>
                                All Types
                            </option>
                            <option value="store">Store</option>
                            <option value="foodpanda"> Food Panda</option>
                            <option value="grabfood"> Grab Food </option>
                        </Form.Select>
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_from}
                            name="date_from"
                            placeholderText={today}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter me-4 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_to}
                            name="date_to"
                            placeholderText={today}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter ps-label-content me-5 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                    </Row>
                    <div className="mb-2" />

                    <div className=" PO-filters d-flex justify-content-center">
                        {/* <span className="me-4 ml-4 mt-2 ps-label">
                            Total Quantity: {numberFormat(totalQuantity)}
                        </span> */}
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total Sales: {numberFormat(totalSales)}
                        </span>
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total Discount: {numberFormat(totalDiscount)}
                        </span>
                    </div>

                    <div className="below">
                        {/* table */}
                        <TableWithDynamicPagination
                            tableHeaders={[
                                "ORDER NO",
                                "ORDER DATE",
                                "BRANCH",
                                "SUBTOTAL",
                                "DISCOUNT",
                                "DISCOUNT DETAILS",
                                "GRAND TOTAL",
                                "REMARKS",
                            ]}
                            headerSelector={[
                                "order_no",
                                "order_date",
                                "branch",
                                "subtotal",
                                "discount",
                                "discount_details",
                                "grand_total",
                                "remarks",
                            ]}
                            tableData={allData}
                            showLoader={showLoader}
                            // used in dynamic pagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
                <div className="mb-3" />
                <br /><br />
                <Row>
                    <Col lg={10}></Col>
                    <Col lg={2} className="mt-3 mt-lg-0">
                    <div className="PO-filters">
                        <button
                            type="button"
                            className="primary-btn"
                            onClick={handleExport}
                        >
                            <span className="me-2">
                                <img
                                    width={20}
                                    height={20}
                                    src={downloadIcon} alt=""
                                ></img>
                            </span>
                            Download
                        </button>
                    </div>
                    </Col>
                </Row>
                <div className="mb-3" />
                <br /><br />
            </div>
            <Footer/>
        </div>
    );
}
